
import React, { useState, useEffect } from "react";
import { postData } from "../../../../services/library";
import { Grid, TextField, Button, DialogContent, Dialog, DialogTitle, Alert, AlertTitle, DialogContentText } from "@mui/material";
import { logEventos } from "../../../../services/services";
import Notify from "../../../Notify";
import moment from "moment";
//ESTO LO PODEMOS TIRAR

export default function AddPrecioEspecialDireccion(props) {
  const [datoslista, setDatoslista] = useState({
    // uuid_direccionentrega: "",
    id_cliente: props.datos.id,
    lt_con_iva: "",
    lt_sin_iva: "",
    kg_con_iva: "",
    kg_sin_iva: "",
    vigencia: null,
    fin_vigencia: null
  });
  const [disabledGuardar, setDisabledGuardar] = useState(false);

  const [notificacion, setNotificacion] = useState({
    open: false,
    mensaje: "",
    severity: "",
    color: "",
  });

  //**********************************************************************************************************************************//
  const style = {
    backgroundColor: "#ffffff",
    width: "100%",
  };
  const size = "small";

  const handleClose = () => {
    props.alta(false);
    props.tabla && props.tabla(true);
  };

  // console.log("datoslista", datoslista);


  //*************************** GUARDAR *******************************************************************************************************//
  const guardarPrecio = async (e) => {
    setDisabledGuardar(false);

    const getNumericValue = (value) => {
      if (!value || typeof value !== 'string') return 0;
      const normalized = value.replace(',', '.');
      const parsed = parseFloat(normalized);
      return isNaN(parsed) ? 0 : parsed;
    };

    const precios = {
      lt_con_iva: getNumericValue(datoslista.lt_con_iva),
      lt_sin_iva: getNumericValue(datoslista.lt_sin_iva),
      kg_con_iva: getNumericValue(datoslista.kg_con_iva),
      kg_sin_iva: getNumericValue(datoslista.kg_sin_iva),
    };

    if (Object.values(precios).some(val => val === 0)) {
      setNotificacion({
        open: true,
        mensaje: "Todos los precios deben ser mayores a 0",
        severity: "error",
        color: "#f44336",
      });
      setDisabledGuardar(false);
      return;
    }

    postData(e, '/precios_especiales',
      {
        // uuid_direccionentrega: props.direccion.nro_dir,
        id_cliente: datoslista.id_cliente,
        ...precios,
        vigencia: datoslista.vigencia,
        usuario: localStorage.getItem("user"),
        fin_vigencia: datoslista.fin_vigencia ?? null
      },
      setNotificacion
    )
    props.actualizar()
    logEventos("Guardar nuevo precio especial desde alta pedidos", "Precio especiales", "AddpedidosList", localStorage.getItem('user'));
  };

  // console.log("fin vigencia", datoslista.fin_vigencia)

  const almacenar = (event) => {
    //a medida que voy llenando los datos, hago directamente el calculo 

    const { name, value } = event.target;
    let newValue = { ...datoslista, [name]: value };

    if (value === "") {
      setDatoslista({
        ...datoslista,
        lt_sin_iva: "",
        lt_con_iva: "",
        kg_sin_iva: "",
        kg_con_iva: "",
        [name]: "",
      });
      return;
    };

    // Si llegó hasta acá, significa que el valor es válido para cálculos
    const valorNormalizado = value.replace(',', '.');
    const floatValue = parseFloat(valorNormalizado);

    if (isNaN(floatValue)) {
      setDatoslista(newValue); // Si aún no se puede parsear, no hacemos cálculos
      return;
    }
    //entonces en cada campo hago lo siguiente mi reynis
    //depende en el cmampo que estoy hago el calculo con el valor del porcentaje de iva del producto
    // que obtengo de la direccion de entrega seleccionada ja ja ja y  ademas con la densidad base del prducto lleno todo porque soy muy inteligente 

    const densidad = props.datos.id_empresa === 1
      ? props.direccion[0]?.densidad_hipergas
      : props.direccion[0]?.densidad_autogas;
    // console.log("densidad", densidad);
    
    // console.log("demsoda", props.datos.id_empresa === 1);
    // console.log("direccion", props.direccion);
    //props.direccion[0]?.valor
    const truncar = (num) =>
      Number(num).toFixed(2).replace('.', ',');

    if (name === "lt_sin_iva") {
      const precioConIva = floatValue * props.direccion[0]?.valor;
      const kgConIva = precioConIva / densidad;
      const kgSinIva = kgConIva / props.direccion[0]?.valor;
      newValue.kg_sin_iva = truncar(kgSinIva);
      newValue.lt_con_iva = truncar(precioConIva);
      newValue.kg_con_iva = truncar(kgConIva);

    }

    if (name === "kg_sin_iva") {
      const precioConIva = floatValue * props.direccion[0]?.valor;
      const ltConIva = precioConIva * densidad;
      const ltSinIva = ltConIva / props.direccion[0]?.valor;
      newValue.kg_con_iva = truncar(precioConIva);
      newValue.lt_con_iva = truncar(ltConIva);
      newValue.lt_sin_iva = truncar(ltSinIva);

    }

    if (name === "kg_con_iva") {
      const precioSinIva = floatValue / props.direccion[0]?.valor;
      const ltConIva = precioSinIva / densidad;
      const ltSinIva = ltConIva / props.direccion[0]?.valor;
      newValue.lt_sin_iva = truncar(ltSinIva);
      newValue.kg_sin_iva = truncar(precioSinIva);
      newValue.lt_con_iva = truncar(ltConIva);

    }

    if (name === "lt_con_iva") {
      const precioSinIva = floatValue / props.direccion[0]?.valor;
      const kgSinIva = precioSinIva * densidad;
      const kgConIva = kgSinIva * props.direccion[0]?.valor;
      newValue.kg_con_iva = truncar(kgConIva);
      newValue.lt_sin_iva = truncar(precioSinIva);
      newValue.kg_sin_iva = truncar(kgSinIva);

    }

    setDatoslista(newValue)

  };

  //*************************** HABILITAR Y DESHABILITAR BOTON GUARDAR ***************************************************************************************//
  useEffect(() => {
    if (datoslista.lt_con_iva === "" || datoslista.lt_sin_iva === "" || datoslista.kg_con_iva === "" || datoslista.kg_sin_iva === "" || datoslista.vigencia === "") {
      setDisabledGuardar(true);
    } else {
      setDisabledGuardar(false);
    }
  }, [datoslista]);

  const handleKeyDown = (e) => {

    // Permitir números y la coma
    if (!(
      (e.key >= '0' && e.key <= '9') ||
      e.key === ',' ||
      e.key === 'Backspace' ||  // permitir borrar
      e.key === 'ArrowLeft' ||   // permitir mover cursor
      e.key === 'ArrowRight' ||
      e.key === 'Tab'             // permitir tabular
    )) {
      e.preventDefault();
    }
  }


  return (
    <div>
      <Dialog
        maxWidth="xl"
        open={props.open}
        onClose={() => props.onClose()}
        style={{ zIndex: 1 }}
      >
        <DialogContent>
          <Alert severity="warning">
            <AlertTitle>Atención</AlertTitle>
            No hay una lista de precios registrada para este cliente
          </Alert>
          <br />
          <DialogContentText>
            A continuación puede registrar una nueva
          </DialogContentText>
          <br />
          <form onSubmit={guardarPrecio} autoComplete="off">

            <Grid
              container
              justifyContent="center"
              alignItems="center"
              spacing={2}
            >
              <Grid item xs={2}>
                <TextField
                  fullWidth
                  size={size}
                  style={style}
                  focused
                  color="primary"
                  required
                  name="lt_sin_iva"
                  label="Precio litro sin IVA"
                  variant="outlined"
                  value={datoslista.lt_sin_iva}
                  onChange={almacenar}
                  onKeyDown={(e) => { handleKeyDown(e) }}
                  onPaste={(e) => {
                    const pastedText = e.clipboardData.getData('text');
                    if (pastedText.includes('.')) {
                      e.preventDefault();
                    }
                  }}
                  inputProps={{
                    inputMode: 'decimal',
                    pattern: '[0-9]*[,]{0,1}[0-9]{0,2}',
                  }}
                />
              </Grid>
              <Grid item xs={2}>
                <TextField
                  fullWidth
                  size={size}
                  style={style}
                  focused
                  color="primary"
                  required
                  name="lt_con_iva"
                  label="Precio litro con IVA"
                  variant="outlined"
                  value={datoslista.lt_con_iva}
                  onChange={almacenar}
                  onKeyDown={(e) => { handleKeyDown(e) }}
                  onPaste={(e) => {
                    const pastedText = e.clipboardData.getData('text');
                    if (pastedText.includes('.')) {
                      e.preventDefault();
                    }
                  }}
                  inputProps={{
                    inputMode: 'decimal',
                    pattern: '[0-9]*[,]{0,1}[0-9]{0,2}',
                  }}
                />
              </Grid>

              <Grid item xs={2}>
                <TextField
                  fullWidth
                  size={size}
                  style={style}
                  focused
                  color="primary"
                  required
                  name="kg_sin_iva"
                  label="Precio kilo sin IVA"
                  variant="outlined"
                  value={datoslista.kg_sin_iva}
                  onChange={almacenar}
                  onKeyDown={(e) => { handleKeyDown(e) }}
                  onPaste={(e) => {
                    const pastedText = e.clipboardData.getData('text');
                    if (pastedText.includes('.')) {
                      e.preventDefault();
                    }
                  }}
                  inputProps={{
                    inputMode: 'decimal',
                    pattern: '[0-9]*[,]{0,1}[0-9]{0,2}',
                  }}
                />
              </Grid>
              <Grid item xs={2}>
                <TextField
                  fullWidth
                  size={size}
                  style={style}
                  focused
                  color="primary"
                  required
                  name="kg_con_iva"
                  label="Precio kilo con IVA"
                  variant="outlined"
                  value={datoslista.kg_con_iva}
                  onChange={almacenar}
                  onKeyDown={(e) => { handleKeyDown(e) }}
                  onPaste={(e) => {
                    const pastedText = e.clipboardData.getData('text');
                    if (pastedText.includes('.')) {
                      e.preventDefault();
                    }
                  }}
                  inputProps={{
                    inputMode: 'decimal',
                    pattern: '[0-9]*[,]{0,1}[0-9]{0,2}',
                  }}
                />
              </Grid>
              <Grid item xs={2}>
                <TextField
                  fullWidth
                  size={size}
                  style={style}
                  focused
                  color="primary"
                  required
                  type="date"
                  name="vigencia"
                  label="Vigencia"
                  variant="outlined"
                  value={datoslista.vigencia && moment(datoslista.vigencia).format("YYYY-MM-DD")}
                  onChange={almacenar}
                //   InputProps={{
                //     inputProps: {
                //         min: today
                //     }
                // }}
                />
              </Grid>
              <Grid item xs={2}>
                <TextField
                  fullWidth
                  size={size}
                  style={style}
                  focused
                  color="primary"
                  // required
                  type="date"
                  name="fin_vigencia"
                  label="Vigencia"
                  variant="outlined"
                  value={moment(datoslista.fin_vigencia).format("YYYY-MM-DD") || null}
                  onChange={almacenar}
                //   InputProps={{
                //     inputProps: {
                //         min: datoslista.vigencia
                //     }
                // }}
                />

              </Grid>
            </Grid>
            {/* </>
                  )}
                </Grid> */}
            <Grid
              container
              justifyContent="space-between"
              alignItems="flex-end"
              mt={2}
            >
              <Button variant="contained" onClick={() => props.onClose(false)} color="error">
                Volver
              </Button>

              <Button
                variant="contained"
                type="submit"
                color="success"
                disabled={disabledGuardar}
              >
                Guardar Precio
              </Button>
            </Grid>

          </form>
          {notificacion && notificacion.open ? (
            <Notify
              mensaje={notificacion.mensaje}
              open={notificacion.open}
              color={notificacion.color}
              handleClose={() => props.onClose()}
              severity={notificacion.severity}
            />
          ) : null}

        </DialogContent>
      </Dialog>
    </div>
  )
}

//----- Component --------------------------------------------------------/
// Developer :  Daiana Curcio / Nicolas pascucci
// Creation Date :26/06/2024
// Version : 1
// Description : Agregar precios
//------Changes ----------------------------------------------------------//
// Change Date :15/8
// Change by :Candela Grosso
// Change description: Acomode el titulo y saque los console.log
// Change Date :
// Change by :
// Change description:
//========================================================================/